import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import { useDispatch } from 'react-redux';
import { fetchItems } from '../../../../store/actions/item/fetchItems';
import styles from './LoadMoreItems.module.scss';
import { trackUIInteraction } from '../../../../utils/analyticsEvents';
import type { NodeBase } from '../../../../entities/Node';
import type { AppThunkDispatch } from '../../../../store';
import { Spin } from '../../../Spin/Spin';
import SSRIcon from '@ingka/ssr-icon';
import circlePath from '@ingka/ssr-icon/paths/circlepath-two-triangles';
import { FETCH_ITEMS_PAGE_SIZE } from '../../../../utils/data/constants';

const LoadMoreItems = function LoadMoreItems({
  node,
  tree,
}: {
  node: NodeBase;
  tree: string;
}) {
  const categoryId = node.category?.categoryId;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch<AppThunkDispatch>();
  const [lastPage, setLastPage] = useState(false);

  const onClickAction = useCallback(async () => {
    setLoading(true);
    trackUIInteraction('load_more_items', { category: node.id });

    const pageNo = Math.floor(node.children.length / FETCH_ITEMS_PAGE_SIZE);

    const pagination = await dispatch(fetchItems({ tree, node, pageNo })).unwrap();
    setLastPage(pagination.lastPage);
    setLoading(false);
  }, [dispatch, node, tree]);

  if (loading && !node?.children?.length)
    return (
      <div>
        <em>Loading items</em>{' '}
        <Spin spin={loading}>
          <SSRIcon paths={circlePath} />
        </Spin>
      </div>
    );

  return (
    <button
      key={categoryId}
      aria-label="Load more items"
      className={cx(styles.loadMore, { [styles.loading]: loading })}
      disabled={loading || lastPage}
      onClick={onClickAction}
      type="button"
    >
      <span className={styles.text}>
        {`Showing ${node?.children?.length} of ${node?.category?.childItemCount} | Load more items`}
      </span>
      <Spin spin={loading}>
        <SSRIcon width={20} height={20} paths={circlePath} />
      </Spin>
    </button>
  );
};

export default LoadMoreItems;
